export default __webpack_public_path__ + "static/media/undraw_code_review_re_woeb.d77a4ea2.svg";